module.exports = __webpack_public_path__ + "img/bg_bottom.6d931de8.png";